// Store functionality
import actions from './actions';

const state = {
};

// Create a new store
const store = {
  namespaced: true,
  state,
  actions,
};

export default store;
